<template>
    <ProductTypeDetails/>
</template>
<script>
import ProductTypeDetails from '../../components/products/ProductTypeDetails';

export default {
  components: {
    ProductTypeDetails,
  },
};
</script>
